"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformCredentials = void 0;
const AgentToken_1 = require("../agent/AgentToken");
const ProjectToken_1 = require("./ProjectToken");
const CollaborationToken_1 = require("../util/CollaborationToken");
const ShareToken_1 = require("../util/ShareToken");
class PlatformCredentials {
    get agent() {
        return this._agent;
    }
    set agent(value) {
        this._agent = value;
    }
    get share() {
        return this._share;
    }
    set share(value) {
        this._share = value;
    }
    get collaboration() {
        return this._collaboration;
    }
    set collaboration(value) {
        this._collaboration = value;
    }
    // assign the tokens from session token api to credentials
    fromSession(obj) {
        if (obj) {
            this._project = new ProjectToken_1.ProjectToken(obj.projectToken);
            this._agent = new AgentToken_1.AgentToken(obj.agentToken);
            this._share = obj.shareToken ? new ShareToken_1.ShareToken(obj.shareToken) : null;
            this._collaboration = obj.collaborationToken ? new CollaborationToken_1.CollaborationToken(obj.collaborationToken) : null;
        }
    }
    fromJSON(obj) {
        if (obj) {
            this._agent = new AgentToken_1.AgentToken(obj.agent.access_token);
            this._project = new ProjectToken_1.ProjectToken(obj.project.access_token);
        }
    }
    get accessToken() {
        if (this._project) {
            return this._project.rawToken;
        }
        else {
            return '';
        }
    }
    get projectId() {
        if (this.agent) {
            return this._agent.projectId;
        }
        else if (this._project) {
            return this._project.projectId;
        }
        else {
            return '';
        }
    }
    get environmentId() {
        if (this.agent) {
            return this._agent.environmentId;
        }
        else if (this._project) {
            return this._project.environmentId;
        }
        else {
            return '';
        }
    }
}
exports.PlatformCredentials = PlatformCredentials;
//# sourceMappingURL=PlatformCredentials.js.map